export const ProgrammeForm = {

  edit: function() {
    jQuery('#programme-form').find('[type="submit"]').attr('disabled', true);
    import("../components/form_editor/form_editor_api.jsx").then(mod => {
      const FormEditorApi = mod.default;

      jQuery('#programme-form').on('submit', function() {
        jQuery(this).append('<input type="hidden" name="form" />');
        jQuery(this).find('input[name="form"]').val(JSON.stringify(FormEditorApi.getFormJSON()));
      });

      jQuery('.form-preview').on('click', ActionJS.ProjectCallPhase.preview_form);

      jQuery('.form-preview-pdf').on('click', ActionJS.ProjectCallPhase.preview_form_pdf);
      jQuery('#programme-form').find('[type="submit"]').attr('disabled', false);

    });
  },

  list: function() {
    Dropdown.useSubmenu();
  },

  update: function() {
    this.edit();
  },

  // Explanation dialoge
  initAnnexEdit: function(){
    jQuery('.concept-note-form').submit(function(e){
      
      e.preventDefault();
      var form = jQuery(this);
      ExplanationDialog.open(function(explanation){

        $.ajax({
          url: form.attr('action'),
          type: 'POST',
          data: form.serialize() + '&explanation=' + encodeURI(explanation) + '&status=submitted',
          async: true
        }).done(function(content) {
          Turbo.visit(location.href, {action: 'replace'});
          ExplanationDialog.close()
        });

      }, '<p>' + I18n.t('form_edit_reason') + '</p>');

      return false;
    });
  },
  
  priv: {
    bindEvent: function(){
      jQuery('.form-clone-link, .form-delete-link').off('click').on('click', function(e){
        e.stopPropagation();
        var c = true;
        if (jQuery(this).data('confirm')){
          c = confirm(jQuery(this).data('confirm'));
        } 
        if (c) {
          jQuery.ajax({
            url: jQuery(this).attr('href'),
            method: 'POST',
            headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
          }).done(function(d){
            Turbo.visit(location.href, {action: 'replace'});
          });
        }
        e.preventDefault();
      });
    }
  }
};